import * as React from "react";
import { forwardRef, memo } from "react";
const SvgGa = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 400 300", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { fill: "#3a75c4", width: 400, height: 300 }), /* @__PURE__ */ React.createElement("rect", { fill: "#fcd116", width: 400, height: 200 }), /* @__PURE__ */ React.createElement("rect", { fill: "#009e60", width: 400, height: 100 }));
const ForwardRef = forwardRef(SvgGa);
const Memo = memo(ForwardRef);
export default Memo;
